/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A guarantee of the quote in a validation snapshot.
 * @export
 * @interface DevisPhotoGarantie
 */
export interface DevisPhotoGarantie {
    /**
     * 
     * @type {string}
     * @memberof DevisPhotoGarantie
     */
    garantieDevisId: string;
    /**
     * Referential guarantee.
     * @type {string}
     * @memberof DevisPhotoGarantie
     */
    garantieId: string;
    /**
     * 
     * @type {string}
     * @memberof DevisPhotoGarantie
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisPhotoGarantie
     */
    designation?: string | null;
    /**
     * Ceiling chosen for the client, null when none.
     * @type {number}
     * @memberof DevisPhotoGarantie
     */
    plafond?: number | null;
    /**
     * Deductible chosen for the client, null when none.
     * @type {number}
     * @memberof DevisPhotoGarantie
     */
    franchise?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DevisPhotoGarantie
     */
    primeTtc: number;
}

/**
 * Check if a given object implements the DevisPhotoGarantie interface.
 */
export function instanceOfDevisPhotoGarantie(value: object): value is DevisPhotoGarantie {
    if (!('garantieDevisId' in value) || value['garantieDevisId'] === undefined) return false;
    if (!('garantieId' in value) || value['garantieId'] === undefined) return false;
    if (!('primeTtc' in value) || value['primeTtc'] === undefined) return false;
    return true;
}

export function DevisPhotoGarantieFromJSON(json: any): DevisPhotoGarantie {
    return DevisPhotoGarantieFromJSONTyped(json, false);
}

export function DevisPhotoGarantieFromJSONTyped(json: any, ignoreDiscriminator: boolean): DevisPhotoGarantie {
    if (json == null) {
        return json;
    }
    return {
        
        'garantieDevisId': json['garantieDevisId'],
        'garantieId': json['garantieId'],
        'code': json['code'] == null ? undefined : json['code'],
        'designation': json['designation'] == null ? undefined : json['designation'],
        'plafond': json['plafond'] == null ? undefined : json['plafond'],
        'franchise': json['franchise'] == null ? undefined : json['franchise'],
        'primeTtc': json['primeTtc'],
    };
}

export function DevisPhotoGarantieToJSON(json: any): DevisPhotoGarantie {
    return DevisPhotoGarantieToJSONTyped(json, false);
}

export function DevisPhotoGarantieToJSONTyped(value?: DevisPhotoGarantie | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'garantieDevisId': value['garantieDevisId'],
        'garantieId': value['garantieId'],
        'code': value['code'],
        'designation': value['designation'],
        'plafond': value['plafond'],
        'franchise': value['franchise'],
        'primeTtc': value['primeTtc'],
    };
}

